import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Feature } from '../../models';

import * as IconFactory from '../../services/icon.factory';
import { deepClone } from '../../utils';

@Component({
    selector: 'kp-map-feature-editor',
    templateUrl: './kp-map-feature-editor.component.html',
    styleUrls: ['./kp-map-feature-editor.component.scss'],
})
export class KpMapFeatureEditorComponent {
    @Input() feature: Feature;

    @Output() remove: EventEmitter<string> = new EventEmitter();
    @Output() ok: EventEmitter<Feature> = new EventEmitter();
    @Output() cancel: EventEmitter<void> = new EventEmitter();
    @Output() mutation: EventEmitter<Feature> = new EventEmitter();
    @Output() uploadImg: EventEmitter<File> = new EventEmitter();

    mutatable: Feature;
    icons = {
        image: undefined,
        del: undefined,
    };

    constructor(private domSanitizer: DomSanitizer) {
        // Have factory create the icons for the UI
        for (const key of Object.keys(this.icons)) {
            this.icons[key] = domSanitizer.bypassSecurityTrustUrl(IconFactory.dataUrlFromIconName(key));
        }
    }

    ngOnChanges() {
        this.mutatable = deepClone(this.feature);
    }

    mutate(): void {
        this.mutation.emit(deepClone(this.mutatable));
    }
    addImg(target: any) {
        const fl: FileList = target.files;
        const file: File = fl[0];

        if (file) {
            this.uploadImg.emit(file);
            this.mutatable.properties.backgroundImageFileName = file.name;
            this.mutate();
        }
    }
    removeImage() {
        delete this.mutatable.properties.backgroundImageFileName;
        delete this.mutatable.properties.url;
        this.mutate();
    }

    requestRemove(): void {
        this.remove.emit(this.feature.properties.id);
    }
    requestOK(): void {
        this.ok.emit(deepClone(this.mutatable));
    }
    requestCancel(): void {
        // Revert local changes first
        this.mutation.emit(deepClone(this.feature));
        this.cancel.emit();
    }
}
